{
  "decrease": "Sumažinti {fieldLabel}",
  "increase": "Padidinti {fieldLabel}",
  "numberField": "Numerio laukas"
}
